var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flowbite:google-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.537 21.998C9.84067 21.9592 7.26709 20.8645 5.369 18.949C4.44129 18.0131 3.70974 16.9015 3.21726 15.6792C2.72477 14.4569 2.48126 13.1486 2.501 11.831C2.56341 9.20067 3.66508 6.70212 5.565 4.882C7.48869 3.03895 10.0479 2.00695 12.712 2H12.888C15.333 2.01214 17.6877 2.92498 19.502 4.564L16.957 6.88C15.819 5.86847 14.3486 5.31105 12.826 5.314C11.0407 5.30745 9.32234 5.99314 8.032 7.227C7.40094 7.83009 6.89537 8.55203 6.54441 9.35126C6.19344 10.1505 6.00401 11.0113 5.987 11.884C5.97287 12.7566 6.13193 13.6233 6.45498 14.434C6.77802 15.2447 7.25863 15.9833 7.869 16.607C9.11714 17.8819 10.8106 18.6238 12.594 18.677H12.737C14.147 18.749 15.537 18.323 16.654 17.477C17.7656 16.6395 18.537 15.4284 18.826 14.067L18.869 13.95H12.72V10.54H22.398C22.4733 11.158 22.5067 11.7777 22.498 12.399C22.399 18.14 18.481 21.999 12.752 21.999L12.537 21.998Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/ic_google.ebc143dee3405d9e8c4c0836d1469464.svg";
export { ForwardRef as ReactComponent };